(function () {
    const adplaceholder = {
        init: function () {
            $('.js__toggleAdForm').on('click', function (e) {
                e.preventDefault();
                const elemToToggle = '#' + $(this).data('toggle');
                $(elemToToggle).slideToggle();
            });
        },
    };
    UX.adplaceholder = adplaceholder; // add to global namespace
})();
